import "./App.css";
import SplineScene from "./components/SplineScene";

function App() {
  return (
    <div className="h-screen">
      <SplineScene />
    </div>
  );
}

export default App;
